import { DetailsContainer } from 'Components/shared/details-container'
import useSession from 'Hooks/session.hook';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AccountRole, DataListType } from 'Types/common.types'
import { FetchedUserData } from 'Types/user.types';

interface EmploymentDetailsProps {
  userDetails:FetchedUserData;
}

const EmploymentDetails:React.FC<EmploymentDetailsProps> = ({
  userDetails,
}) => {

  const { t } = useTranslation();
  const { org } = useSession();

  const employmentInfo: DataListType[] = [
    {
      label: t("label.department"),
      value: userDetails?.userRole?.department ?? "-",
    },
    {
      label: t("label.roleSubType"),
      value: userDetails?.userRole?.subType ?? "-",
    },
  ]

  useEffect(() => {
    if (userDetails.userRole?.type === AccountRole.CUSTOMER) {
      employmentInfo.unshift({
        label: t("label.company").toUpperCase(),
        value: userDetails.org?.name ?? "-",
      },
        {
          label: t("label.location"),
          value: userDetails.locationName ?? "-",
        }
      )
    }
  }, [])
  
  return (
    <div>
      <DetailsContainer
        listOfData={employmentInfo}
      />
    </div>
  )
}

export default EmploymentDetails